<template>
  <v-container id="dashboard" fluid tag="section" class="dashboard-container">
    <!-- Loading Progress Bar -->
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
      height="4"
      class="mb-0"
    />

    <!-- Main Content -->
    <v-row>
      <!-- Main Statistics Card -->
      <v-col cols="12">
        <v-card class="elevation-8 rounded-lg">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-chart-line</v-icon>
            <span class="text-h5">รายงานผลสรุป</span>
          </v-card-title>

          <!-- Teacher Transfer Statistics -->
          <v-card-text v-if="period_teach.period_enable_process === '1'">
            <v-row>
              <v-col cols="12">
                <v-card class="info-card mb-4" outlined>
                  <v-card-title class="text-center primary--text">
                    <v-icon left color="primary">mdi-school</v-icon>
                    การย้ายข้าราชการครูและบุคลากรทางการศึกษา ตำแหน่งครู
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-card
                          class="stat-card text-center"
                          color="blue-grey lighten-5"
                        >
                          <v-card-text>
                            <div class="text-h4 primary--text">
                              {{ conditions_transfers.count_condition }}
                            </div>
                            <div class="text-subtitle-1">จำนวนวิทยาลัย</div>
                            <div class="text-caption">
                              {{ conditions_transfers.percent_t }}%
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-card
                          class="stat-card text-center"
                          color="blue lighten-5"
                        >
                          <v-card-text>
                            <div class="text-h4 blue--text">
                              {{ tpsnormal.count_personnel }}
                            </div>
                            <div class="text-subtitle-1">
                              ผู้ยื่นย้าย (กรณีปกติ)
                            </div>
                            <div class="text-caption">
                              {{ tpsnormal.percent_p }}%
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-card
                          class="stat-card text-center"
                          color="red lighten-5"
                        >
                          <v-card-text>
                            <div class="text-h4 red--text">
                              {{ tpsspecial.count_personnel }}
                            </div>
                            <div class="text-subtitle-1">
                              ผู้ยื่นย้าย (กรณีพิเศษ)
                            </div>
                            <div class="text-caption">
                              {{ tpsspecial.percent_p }}%
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- Management Transfer Statistics -->
          <v-card-text
            v-if="
              period_manage.period_enable_process === '1' ||
                period_manage.period_enable === '1'
            "
          >
            <v-row>
              <!-- Director Statistics -->
              <v-col cols="12" md="6">
                <v-card class="management-card" outlined>
                  <v-card-title class="text-center indigo--text">
                    <v-icon left color="indigo">mdi-account-tie</v-icon>
                    ผู้อำนวยการ
                  </v-card-title>

                  <v-card-text>
                    <v-row class="text-center">
                      <v-col cols="6">
                        <div class="text-h3 indigo--text">
                          {{ transference_manages.count_dr }}
                        </div>
                        <div class="text-subtitle-2">จำนวน (คน)</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="text-h3 indigo--text">
                          {{ transference_manages.percent_dr }}%
                        </div>
                        <div class="text-subtitle-2">ร้อยละ</div>
                      </v-col>
                    </v-row>

                    <v-divider class="my-3"></v-divider>

                    <v-row class="text-center">
                      <v-col cols="4">
                        <div class="text-h6 red--text">
                          {{ transference_manages.count_dr_special }}
                        </div>
                        <div class="text-caption">กรณีพิเศษ</div>
                      </v-col>
                      <v-col cols="4">
                        <div class="text-h6 blue--text">
                          {{ transference_manages.count_dr_normal }}
                        </div>
                        <div class="text-caption">ปกติ</div>
                      </v-col>
                      <v-col cols="4">
                        <div class="text-h6 green--text">
                          {{ transference_manages.count_dr_quality }}
                        </div>
                        <div class="text-caption">พัฒนาคุณภาพ</div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Deputy Director Statistics -->
              <v-col cols="12" md="6">
                <v-card class="management-card" outlined>
                  <v-card-title class="text-center purple--text">
                    <v-icon left color="purple">mdi-account-supervisor</v-icon>
                    รองผู้อำนวยการ
                  </v-card-title>

                  <v-card-text>
                    <v-row class="text-center">
                      <v-col cols="6">
                        <div class="text-h3 purple--text">
                          {{ transference_manages.count_sedr }}
                        </div>
                        <div class="text-subtitle-2">จำนวน (คน)</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="text-h3 purple--text">
                          {{ transference_manages.percent_sedr }}%
                        </div>
                        <div class="text-subtitle-2">ร้อยละ</div>
                      </v-col>
                    </v-row>

                    <v-divider class="my-3"></v-divider>

                    <v-row class="text-center">
                      <v-col cols="6">
                        <div class="text-h6 red--text">
                          {{ transference_manages.count_sedr_special }}
                        </div>
                        <div class="text-caption">กรณีพิเศษ</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="text-h6 blue--text">
                          {{ transference_manages.count_sedr_normal }}
                        </div>
                        <div class="text-caption">ปกติ</div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Component Sections -->
      <v-col cols="12">
        <personnel_temporary_notifyVue />
      </v-col>

      <!--   <v-col cols="12">
        <Personnel_etcSummary_years />
      </v-col> -->

      <v-col cols="12">
        <personnel_etcSummarySubject />
      </v-col>

      <v-col cols="12">
        <personnel_etcSummary />
      </v-col>

      <!-- Summary Components -->
      <v-col cols="12">
        <personnel_etcSummaryBranch />
      </v-col>

      <v-col cols="12">
        <temporarycollegeemreg />
      </v-col>
      <v-col cols="12">
        <temporaryemployees />
      </v-col>
    </v-row>

    <!-- Floating Action Button for Refresh -->
    <v-btn
      fab
      fixed
      bottom
      right
      color="primary"
      @click="refreshData"
      :loading="loading"
    >
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import personnel_temporary_notifyVue from "../../component/personnel_temporary_notify.vue";
import personnel_etcSummary from "../../component/personnel_etcSummary.vue";
import personnel_etcSummarySubject from "../../component/personnel_etcSummarySubject.vue";
import Personnel_etcSummary_years from "../../component/personnel_etcSummary_years.vue";
import personnel_etcSummaryBranch from "../../component/personnel_etcSummaryBranch.vue";
import temporarycollegeemreg from "../../component/temporarycollegeemreg.vue";
import temporaryemployees from "../../component/temporaryemployees";

export default {
  name: "DashboardDashboard",
  components: {
    personnel_temporary_notifyVue,
    temporarycollegeemreg,
    temporaryemployees,
    personnel_etcSummary,
    personnel_etcSummaryBranch,
    personnel_etcSummarySubject,
    Personnel_etcSummary_years
  },

  data() {
    return {
      // Configuration
      ApiKey: "HRvec2021",

      // UI State
      loading: true,
      dialogLoading: true,
      search: "",
      search_branch: "",

      // Pagination
      pagination: {},
      rowsperpage: [25, 50, 100, { text: "All", value: -1 }],

      // Data Arrays
      user: [],
      colleges: [],
      provinces: [],
      prefectures: [],
      regions: [],
      showAlldata: {},
      showAlldata_rang: [],
      showcollegedata: {},
      showbranchdata: [],

      // Transfer Statistics
      tpsnormal: [],
      tpsspecial: [],
      conditions_transfers: [],
      transference_manages: [],

      // Periods
      period_teach: [],
      period_manage: [],

      // Chart Data
      personnel_rangChart: {
        data: {
          labels: ["ครูผู้ช่วย", "คศ.1", "คศ.2", "คศ.3", "คศ.4", "คศ.5"],
          series: [[0, 0, 0, 0, 0, 0]]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({ tension: 0 }),
          low: 0,
          high: 5000,
          chartPadding: { top: 0, right: 10, bottom: 0, left: 0 }
        }
      },

      Personnel_chart: {
        data: {
          labels: [
            "ผู้อำนวยการ",
            "รองผู้อำนวยการ",
            "ครู",
            "ครูผู้ช่วย",
            "ศึกษานิเทศก์"
          ],
          series: [[0, 0, 0, 0, 0]]
        },
        options: {
          axisX: { showGrid: false },
          low: 0,
          high: 14000,
          chartPadding: { top: 0, right: 5, bottom: 0, left: 10 }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 100%)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },

      // Table Headers
      headers: [
        { text: "รหัสสถานศึกษา", align: "left", value: "college_code" },
        { text: "ชื่อสถานศึกษา", align: "left", value: "college_name" },
        { text: "อำเภอ", align: "left", value: "prefecture_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "ประเภทสถานศึกษา", align: "left", value: "collegetype_name" },
        { text: "เบอร์โทร", align: "left", value: "collegeinfo_phone" }
      ],

      header_branchs: [
        { text: "รหัสสาขา", align: "center", value: "id_branch" },
        { text: "สาขาวิชา", align: "left", value: "name_branch" },
        { text: "รายละเอียด", align: "left", value: "detail_branch" }
      ],

      // Filters
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],
      times_select: "1",
      years_select: "2565",

      // Other
      interval: {},
      value: 0,
      region_ena: true
    };
  },

  async mounted() {
    try {
      await this.initializeData();
    } catch (error) {
      console.error("Error initializing dashboard:", error);
      this.$toast.error("เกิดข้อผิดพลาดในการโหลดข้อมูล");
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async initializeData() {
      const loadingTasks = [
        this.loadBasicData(),
        this.period_teachQuery(),
        this.period_manageQuery(),
        this.getuser(),
        this.getAlldata(),
        this.getAlldata_rang(),
        this.getPersonnelChart(),
        this.getPersonnel_rangChart(),
        this.getAllbranchdata(),
        this.searchTimeYear()
      ];

      await Promise.all(loadingTasks);
    },

    async loadBasicData() {
      const requests = [
        this.$http.post("collegetype.php", { ApiKey: this.ApiKey }),
        this.$http.post("college.php", { ApiKey: this.ApiKey }),
        this.$http.post("province.php", { ApiKey: this.ApiKey }),
        this.$http.post("region.php", { ApiKey: this.ApiKey })
      ];

      const [collegetypes, colleges, provinces, regions] = await Promise.all(
        requests
      );

      this.collegetypes = collegetypes.data;
      this.colleges = colleges.data;
      this.provinces = provinces.data;
      this.regions = regions.data;
    },

    async period_teachQuery() {
      const result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_type: "teacher"
      });
      this.period_teach = result.data;
    },

    async period_manageQuery() {
      const result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_enable: "1",
        period_type: "manage",
        periord_admin: "check"
      });
      this.period_manage = result.data;
    },

    async searchTimeYear() {
      try {
        if (
          this.period_teach.period_enable === "1" ||
          this.period_teach.period_enable_process === "1"
        ) {
          const requests = [
            this.$http.post("transference_personnel.php", {
              ApiKey: this.ApiKey,
              time_s: this.period_teach.period_times,
              year_s: this.period_teach.period_year,
              type_move: "nm",
              count_s: "ok"
            }),
            this.$http.post("transference_personnel.php", {
              ApiKey: this.ApiKey,
              time_s: this.period_teach.period_times,
              year_s: this.period_teach.period_year,
              type_move: "sp",
              count_s: "ok"
            }),
            this.$http.post("conditions_transfer_admin.php", {
              ApiKey: this.ApiKey,
              time_s: this.period_teach.period_times,
              year_s: this.period_teach.period_year,
              count_s: "ok"
            })
          ];

          const [normal, special, conditions] = await Promise.all(requests);
          this.tpsnormal = normal.data;
          this.tpsspecial = special.data;
          this.conditions_transfers = conditions.data;
        }

        if (
          this.period_manage.period_enable_process === "1" ||
          this.period_manage.period_enable === "1"
        ) {
          const result = await this.$http.post("transference_manage.php", {
            ApiKey: this.ApiKey,
            manage_time_s: this.period_manage.period_times,
            manage_year_s: this.period_manage.period_year,
            count_s: "ok"
          });
          this.transference_manages = result.data;
        }
      } catch (error) {
        console.error("Error in searchTimeYear:", error);
      }
    },

    async getuser() {
      const userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      if (userSession.user_name) {
        const result = await this.$http.post("admin.php", {
          user_name: userSession.user_name,
          ApiKey: this.ApiKey
        });
        this.user = result.data;
      }
    },

    async getAlldata() {
      const result = await this.$http.post("show_dashboard_all.php");
      this.showAlldata = result.data;
    },

    async getAlldata_rang() {
      const result = await this.$http.post("show_dachboard_rang.php");
      this.showAlldata_rang = result.data;
    },

    async getPersonnelChart() {
      this.Personnel_chart.data.series = [
        [
          this.num_dr,
          this.num_se_dr,
          this.num_se_tech,
          this.num_se_techprepare,
          this.num_se_supervision
        ]
      ];
    },

    async getPersonnel_rangChart() {
      this.personnel_rangChart.data.series = [
        [
          this.num_rang_0,
          this.num_rang_1,
          this.num_rang_2,
          this.num_rang_3,
          this.num_rang_4,
          this.num_rang_5
        ]
      ];
    },

    async getAllbranchdata() {
      const result = await this.$http.post("branch.php", {
        ApiKey: this.ApiKey
      });
      this.showbranchdata = result.data;
    },

    async refreshData() {
      this.loading = true;
      try {
        await this.initializeData();
        this.$toast.success("ข้อมูลได้รับการอัปเดตแล้ว");
      } catch (error) {
        this.$toast.error("เกิดข้อผิดพลาดในการอัปเดตข้อมูล");
      } finally {
        this.loading = false;
      }
    }
  },

  computed: {
    num_dr() {
      return parseInt(this.showAlldata.count_dr || 0);
    },
    num_se_dr() {
      return parseInt(this.showAlldata.count_se_dr || 0);
    },
    num_se_tech() {
      return parseInt(this.showAlldata.count_tech || 0);
    },
    num_se_techprepare() {
      return parseInt(this.showAlldata.count_perpare || 0);
    },
    num_se_supervision() {
      return parseInt(this.showAlldata.count_supervision || 0);
    },
    num_rang_0() {
      return parseInt(this.showAlldata_rang.count_rang0 || 0);
    },
    num_rang_1() {
      return parseInt(this.showAlldata_rang.count_rang1 || 0);
    },
    num_rang_2() {
      return parseInt(this.showAlldata_rang.count_rang2 || 0);
    },
    num_rang_3() {
      return parseInt(this.showAlldata_rang.count_rang3 || 0);
    },
    num_rang_4() {
      return parseInt(this.showAlldata_rang.count_rang4 || 0);
    },
    num_rang_5() {
      return parseInt(this.showAlldata_rang.count_rang5 || 0);
    }
  }
};
</script>

<style scoped>
.dashboard-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

.info-card {
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 15px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.stat-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  border: none !important;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.management-card {
  border-radius: 15px !important;
  transition: all 0.3s ease;
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
}

.management-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
}

.v-card {
  border-radius: 15px !important;
}

.v-expansion-panel {
  border-radius: 10px !important;
  margin-bottom: 8px;
}

.v-expansion-panel-header {
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
}

.v-progress-linear {
  border-radius: 0 0 10px 10px;
}

.v-btn--fab {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .stat-card {
    margin-bottom: 16px;
  }

  .management-card {
    margin-bottom: 16px;
  }
}
</style>
